import { Row, Col } from 'react-bootstrap';
import CreateUser from './CreateUser';
import SearchUser from './SearchUser';
import ProductStock from './ProductStock';
import { useContext } from 'react';
import { AuthContext } from '../../../services/authContext';

const AdminAdmin = () => {

    const { userRoles } = useContext(AuthContext);

    return (
        <>
            {userRoles.includes('Admin') && (
                <Row>
                    <Col xs={12} md={12} lg={6}>
                        <CreateUser />
                    </Col>
                    <Col xs={12} md={12} lg={6}>
                        <SearchUser />
                    </Col>
                </Row>
            )}

            {userRoles.includes('NRT Deliveries') && (
                <Row>
                    <Col xs={12}>
                        <ProductStock />
                    </Col>
                </Row>
            )}
        </>
    );


}
export default AdminAdmin;
